module.exports = __webpack_public_path__ + "static/img/Group 353.5a821511.png";